import React, { PureComponent } from 'react';
import Button from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';

import DomUtils from '../common/utils/DomUtils';

import PropertySheetView, { PropertyPage } from '../common/controls/PropertySheetView';
import PropertySheetDataModel from '../common/controls/PropertySheetDataModel';

import CounterpartiesView from './counterparties/CounterpartiesView';
import CounterpartiesDataModel from './counterparties/CounterpartiesDataModel';

import SettingsView from './settings/SettingsView';
import SettingsDataModel from './settings/SettingsDataModel';

import './ConfigurationMain.css';

export class ConfigurationMain extends PureComponent {
  static displayName = ConfigurationMain.name;

  constructor(props) {
    super(props);

    this.dataModelPropertiesUpdatedHandler = this.onDataModelPropertiesUpdated.bind(this);

    this.parentContainerElement = DomUtils.getElementItemByClassName('pwx-main-container');
    this.resizeObserver = new ResizeObserver(() => requestAnimationFrame(() => this.updateViewHeight()));
    this.resizeObserver.observe(this.parentContainerElement);

    this.propertySheetDataModel = new PropertySheetDataModel();
    this.propertySheetDataModel.addPropertyListener(
      ['isModified', 'hasErrors'],
      this.dataModelPropertiesUpdatedHandler
    );

    this.state = {
      isModified: this.propertySheetDataModel.isModified,
      hasErrors: this.propertySheetDataModel.hasErrors
    };
  }

  componentDidMount() {
    this.updateViewHeight();
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect();
    this.resizeObserver = null;
    this.parentContainerElement = null;

    this.propertySheetDataModel.removePropertyListener(
      this.dataModelPropertiesUpdatedHandler
    );
    this.propertySheetDataModel.dispose();
  }

  render() {
    return (
      <div className="pwx-configuration-view">
        <div className="pwx-configuration-content">
          <PropertySheetView dataModel={this.propertySheetDataModel} fillParent={true} session={this.props.session}>
            <PropertyPage title="Counterparties/Contracts" viewType={CounterpartiesView} dataModelType={CounterpartiesDataModel} />
            <PropertyPage title="Settings" viewType={SettingsView} dataModelType={SettingsDataModel} />
          </PropertySheetView>
        </div>
        
        <div className="pwx-configuration-commandbar">
          <table><tbody><tr>
            <td>
              <Button
                disabled={!this.state.isModified || this.state.hasErrors}
                text="Submit"
                type="success"
                icon="upload"
                onClick={this.onSubmitChanges.bind(this)}
              />
            </td>
            <td width="10" />
            <td>
              <Button
                disabled={!this.state.isModified}
                text="Revert"
                type="default"
                icon="revert"
                onClick={this.onRevertChanges.bind(this)}
              />
            </td>
          </tr></tbody></table>
        </div>

      </div>
    );
  }

  updateViewHeight() {
    if (this.parentContainerElement === null)
      return;

    var viewHeight = this.calculateViewHeight();

    DomUtils.setElementHeight(
      DomUtils.getElementItemByClassName('pwx-configuration-view'),
      viewHeight
    );
    
    var commandBarHeight = DomUtils.getElementItemByClassName('pwx-configuration-commandbar').offsetHeight;
    var tabbedViewHeight = viewHeight - commandBarHeight - 12;

    DomUtils.setElementHeight(
      DomUtils.getElementItemByClassName('pwx-configuration-content'),
      tabbedViewHeight
    );
  }

  calculateViewHeight() {
    return DomUtils.calculateInnerContentHeight(
      DomUtils.getElementItemByClassName('pwx-main-container')
    );
  }

  onDataModelPropertiesUpdated(propertyNames) {
    this.setState({
      isModified: this.propertySheetDataModel.isModified,
      hasErrors: this.propertySheetDataModel.hasErrors
    });
  }

  onSubmitChanges() {
    this.propertySheetDataModel.submitChanges(this.onOperationComplete.bind(this));
  }

  onRevertChanges() {
    this.propertySheetDataModel.revertChanges();
  }

  onOperationComplete(results) {
    if (results.failures === 0 && results.successes > 0)
      notify(`All updates completed successfully.`, 'success', 3000);
    else if (results.failures > 0 && results.successes > 0)
      notify(`${results.successes} update(s) completed successfully, ${results.failures} update(s) failed.`, 'warning', 3000);
    else if (results.failures > 0)
      notify(`The update operation was unsuccessful.`, 'error', 3000);
  }
}